import { call, put, takeLatest } from 'redux-saga/effects'
import { handleApiErrors } from '../../../lib/api-errors'
import axiosApi from '../../../views/client/axiosClient'
import { transfersFromCached } from '../../../lib/common'
import * as saleTotalConstant from './constants'
import * as saleTotalAction from './actions'

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}
function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}
function nvkdRequestApi(formData) {
  const request = axiosApi().post(
    saleTotalConstant.SALE_TOTAL_REPORT_NVKD_API,
    formData
  )

  return handleRequest(request);
}
function* saleTotalReportNvkdRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(nvkdRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(saleTotalAction.saleTotalReportNvkdSuccess(results.data))

  } catch (error) {
    yield put(saleTotalAction.saleTotalReportNvkdError(error))
  }
}
function khRequestApi(formData) {
  const request = axiosApi().post(
    saleTotalConstant.SALE_TOTAL_REPORT_KH_API,
    formData
  )

  return handleRequest(request);
}
function* saleTotalReportKhRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const { data } = yield call(khRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(saleTotalAction.saleTotalReportKhSuccess(transfersFromCached(data)))

  } catch (error) {
    yield put(saleTotalAction.saleTotalReportKhError(error))
  }
}
function khoXuatRequestApi(formData) {
  const request = axiosApi().post(
    saleTotalConstant.SALE_TOTAL_REPORT_KHOXUAT_API,
    formData
  )

  return handleRequest(request);
}
function* saleTotalReportKhoXuatRequestFlow({ payload }) {
  try {
    // grab the client from our action
    const { data } = yield call(khoXuatRequestApi, payload)
    // dispatch the action with our widgets!
    yield put(saleTotalAction.saleTotalReportKhoXuatSuccess(transfersFromCached(data)))

  } catch (error) {
    yield put(saleTotalAction.saleTotalReportKhoXuatError(error))
  }
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    saleTotalConstant.SALE_TOTAL_REPORT_LIST_API,
    formData
  )

  return handleRequest(request);
}


function* saleTotalReportListRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(listRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(saleTotalAction.saleTotalReportListSuccess(results.data))

  } catch (error) {
    yield put(saleTotalAction.saleTotalReportListError(error))
  }
}
function exportXlsRequestApi(formData) {
  const url = saleTotalConstant.SALE_TOTAL_REPORT_EXPORT_XLS_API + "?s=" + formData.store_id + "&st=" + formData.tu_ngay + "&ed=" + formData.den_ngay
    + "&ldh=" + formData.loaiDonHang + "&ql=" + formData.treeQL + "&kd=" + formData.listNvkd
    + "&nkh=" + formData.listNhomKh + "&kh=" + formData.listKH + "&kx=" + formData.listKhoXuat + "&tt=" + formData.trangThai + "&kw=" + formData.keyword;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}
function* reportExportXlsRequestFlow(action) {
  const { formData, callback } = action
  try {
    // grab the client from our action
    const results = yield call(exportXlsRequestApi, formData)
    // dispatch the action with our widgets!
    yield put(saleTotalAction.reportExportXlsSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(saleTotalAction.reportExportXlsError(error))
  }
}
function* saleTotalReportNhomKhRequestFlow({ payload, callback }) {
  try {
    // grab the client from our action
    const request = axiosApi().post(
      saleTotalConstant.SALE_TOTAL_REPORT_NHOMKH_API,
      payload
    )
    const results = yield call(handleRequest, request)
    // dispatch the action with our widgets!
    yield put(saleTotalAction.saleTotalReportNhomKhSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(saleTotalAction.saleTotalReportNhomKhError(error))
  }
}
function* saleTotalReportKhByNhomRequestFlow({ payload, callback }) {
  try {
    // grab the client from our action
    const request = axiosApi().post(
      saleTotalConstant.SALE_TOTAL_REPORT_KH_BY_NHOM_API,
      payload
    )
    const results = yield call(handleRequest, request)
    // dispatch the action with our widgets!
    const data = transfersFromCached(results.data)
    yield put(saleTotalAction.saleTotalReportKhByNhomSuccess(data))
    if (typeof callback == 'function') {
      yield call(callback, data);
    }
  } catch (error) {
    yield put(saleTotalAction.saleTotalReportKhByNhomError(error))
  }
}
function* saleTotalReportWatcher() {
  yield [
    takeLatest(saleTotalConstant.SALE_TOTAL_REPORT_KHOXUAT_REQUESTING, saleTotalReportKhoXuatRequestFlow),
    takeLatest(saleTotalConstant.SALE_TOTAL_REPORT_NVKD_REQUESTING, saleTotalReportNvkdRequestFlow),
    takeLatest(saleTotalConstant.SALE_TOTAL_REPORT_KH_REQUESTING, saleTotalReportKhRequestFlow),
    takeLatest(saleTotalConstant.SALE_TOTAL_REPORT_LIST_REQUESTING, saleTotalReportListRequestFlow),
    takeLatest(saleTotalConstant.SALE_TOTAL_REPORT_EXPORT_XLS_REQUESTING, reportExportXlsRequestFlow),
    takeLatest(saleTotalConstant.SALE_TOTAL_REPORT_NHOMKH_REQUESTING, saleTotalReportNhomKhRequestFlow),
    takeLatest(saleTotalConstant.SALE_TOTAL_REPORT_KH_BY_NHOM_REQUESTING, saleTotalReportKhByNhomRequestFlow),
  ]
}

export default saleTotalReportWatcher



// WEBPACK FOOTER //
// ./src/views/Reports/SaleTotalReport/sagas.js